import { SettingsManager } from "@viamap/viamap2-common";
import { isRunningOnLocalhost } from "./isLocalhost";

const LOCAL_SERVITUT_PROCESSOR_SERVICE_HOST = "http://localhost:8000";

let preferConfiguredOverLocalhost = false;

function getConfiguredServitutProcessorServiceHost(): string {
  const host = SettingsManager.getSystemSetting("ann.servitutProcessorServiceHost");
  return typeof host === "string" ? host.trim() : "";
}

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/+$/, "");
}

function getServitutProcessorServiceHostCandidates(): string[] {
  const configured = getConfiguredServitutProcessorServiceHost();

  if (!isRunningOnLocalhost() || preferConfiguredOverLocalhost) {
    return configured ? [configured] : [];
  }

  const local = LOCAL_SERVITUT_PROCESSOR_SERVICE_HOST;
  if (!configured || normalizeBaseUrl(local) === normalizeBaseUrl(configured)) {
    return [local];
  }

  return [local, configured];
}

function isNetworkFetchError(error: unknown): boolean {
  return error instanceof TypeError;
}

export async function fetchServitutProcessor(path: string, init: RequestInit): Promise<Response> {
  const candidates = getServitutProcessorServiceHostCandidates();
  if (candidates.length === 0) {
    throw new Error("Missing servitut processor service configuration");
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  let lastNetworkError: unknown;

  for (let i = 0; i < candidates.length; i++) {
    const url = `${normalizeBaseUrl(candidates[i])}${normalizedPath}`;
    try {
      return await fetch(url, init);
    } catch (error) {
      const hasFallback = i < candidates.length - 1;
      if (isNetworkFetchError(error) && hasFallback) {
        preferConfiguredOverLocalhost = true;
        lastNetworkError = error;
        continue;
      }
      throw error;
    }
  }

  throw lastNetworkError ?? new Error("Failed to reach servitut processor service");
}
